module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Bakgrunn_for_visa.44424834.jpg";